import PropTypes from "prop-types";
import { useState, useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Login from "../pages/auth/Login";
//* components
import LoadingScreen from "../components/LoadingScreen";

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
	children: PropTypes.node,
};

export default function AuthGuard({ children }) {
	const { pathname, state } = useLocation();
	const isContactCenter = pathname?.includes("contactCenter");
	const [requestedLocation, setRequestedLocation] = useState(null);
	const { isAuth = true, isInit = true } = { ...state };

	const isAuthenticated = isAuth;
	const isInitialized = isInit;

	if (!isInitialized) {
		return <LoadingScreen />;
	}

	if (!isAuthenticated) {
		if (pathname !== requestedLocation) {
			setRequestedLocation(pathname);
		}
		return <Login isContactCenter={isContactCenter} />;
	}

	if (requestedLocation && pathname !== requestedLocation) {
		setRequestedLocation(null);
		return <Navigate to={requestedLocation} />;
	}

	return <>{children}</>;
}
